export enum rootPaths {
  INDEX = '/',
  MAIN = '/main',
  SHOWROOM = '/showroom',
  DEVELOPER = '/developer',
  BOSS = '/boss',
  INTEGRATION = '/integration/dialog',
  INTEGRATION_UYQUR = '/integration/uyqur',
  RESTORE_PASSWORD = '/restore-password',
  CHANGE_PASSWORD = '/change-password',
  QR_CODE = '/qr/:token',
  PAYMENT_QR_CODE = '/qr/payment/:token',
  SCHEDULE_LOTTOTRON = '/schedule-lottotron',
  PRIVACY_POLICY = '/privacy-policy',
  REALTOR = '/realtor',
  AI_AGENT = '/ai-agent'
}
